import {Box} from '@mui/material';
import React from 'react';
import {useMediaQuery} from 'react-responsive';
import styles from './page-body.module.scss';

interface Props {
    justifyContent?: 'center' | 'flex-start';
    alignItems?: 'center' | 'flex-start' | 'stretch';
    children: React.ReactNode;
}

export default function TimeTrackingPageBody({ justifyContent = 'flex-start', alignItems = 'center', children }: Props) {
    const isMobile = useMediaQuery({ maxWidth: 1000 });

    return (
        <Box
            className={styles.pageBody}
            sx={{
                justifyContent,
                alignItems,
                overflowY: isMobile ? 'hidden' : 'auto',
                height: '100%',
                maxHeight: '100%',
                minHeight: 0,
            }}>
            {children}
        </Box>
    );
}
